module.exports = {
	"auctionStatus": {
		"canFinalize": "All lots were cancelled or sold, but you need to finalize the auction. See the panel on the right-hand side."
	},
	"auctionStatusPanel": {
		"header": "Auction Status",
		"status": {
			"cancelled": {
				"description": "The auction was cancelled.",
				"title": "Cancelled"
			},
			"finished": {
				"description": "The auction is over. You can navigate to the post-auction report using the link below.",
				"title": "Completed"
			},
			"ongoing": {
				"description": "The auction is ongoing. Users can participate in bidding activities.",
				"title": "Ongoing"
			},
			"paused": {
				"description": "The auction is paused. Users are being told the auction will need to resume before they can continue bidding.",
				"title": "Paused"
			},
			"pendingFinalization": {
				"description": "The auction is ongoing, but all lots were either sold or cancelled. You can now finalize the auction to generate the post-auction report.",
				"title": "Pending Finalization"
			},
			"waiting": {
				"description": "The auction hasn't started yet. The users are invited to wait.",
				"title": "Waiting"
			}
		},
		"action": {
			"cancel": {
				"option": "Cancel the auction",
				"header": "Cancellation",
				"confirmation": "Are you sure you want to cancel the auction? Lots already sold will remain sold, the remaining lots will be cancelled.",
				"yesButton": "Yes, cancel it.",
				"noButton": "No, keep going."
			},
			"finalize": "Finalize the auction",
			"goToReport": "Consult post-auction report",
			"pause": "Pause the auction",
			"resume": "Resume the auction",
			"start": "Start the auction"
		}
	},
	"controlsPanel": {
		"messagePlaceholder": "Type a message to broadcast to the auction here...",
		"sendButton": "Send",
		"replaceBidButton": {
			"text": "Replace Current Bid With Floor Bid"
		},
		"undoBidButton": {
			"text": "Undo Last Live Bid",
			"title": "The current lot needs to be ongoing or closed for the last live bid to be undone."
		}
	},
	"lotAction": {
		"cancel": "Cancel Lot",
		"jump": "Go To Next Available Lot",
		"lastCall": "Initiate Last Call",
		"open": "Open Lot for Bidding",
		"reopen": "Reopen Lot for Bidding",
		"sell": "Mark Lot as Sold",
		"skip": "Skip Lot and Go To Next"
	},
	"lotCatalog": {
		"action": {
			"cancel": "$t(cancel)",
			"jump": "Set as Current"
		},
		"noLotFound": "No lot found."
	},
	"module": {
		"controls": "Controls"
	},
	"reserve": "Reserve"
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/en/widget-admin.json5
// module id = 1963
// module chunks = 6